// extracted by mini-css-extract-plugin
module.exports = {"filter":"styles_filter__2VOP1","module":"styles_module__gsBZa","desktopFilter":"styles_desktopFilter__30gN6"};